import styled from '@emotion/styled';

import { getContrastFontColor } from '../../../util/getContrastFontColor';
import { S as CardStyles } from '../Card.styles';
import type { CardHeaderProps } from './CardHeader.types';

const Container = styled.div<Pick<CardHeaderProps, 'variant'>>(({ theme, variant }) => {
  const panelColor = theme.stellenportal?.panelStyle?.color;
  const { paddingBlock, paddingInline, borderRadius } = CardStyles.componentConfig(theme);

  return [
    {
      marginBottom: theme.eclipseTier1.spacing['12px'],
    },
    variant === 'panel' && {
      marginTop: `calc(-1 * ${paddingBlock})`,
      marginInline: `calc(-1 * ${paddingInline})`,
      marginBottom: paddingBlock,
      padding: `${theme.eclipseTier1.spacing['12px']} ${paddingInline}`,
      borderRadius: `${borderRadius} ${borderRadius} 0 0`,
      backgroundColor: panelColor || theme.eclipseTier2Color.surface.raised,
      color: panelColor ? getContrastFontColor(panelColor) : theme.eclipseTier2Color.text.default,
    },
  ];
});

export const S = {
  Container,
} as const;
